import { BrowserRouter, Routes, Route } from "react-router-dom";
import Comingsoon from "./coming-soon";

import MainPage from "./homepage";
import MediaAssets from "./media-assets";
import PrivacyPolicy from "./privacy-policy";
import ResearchPage from "./research";
import IgniteStudio from "./xglobal_studio";
import IgniteCoin from "./xglobalcoin";
import Enterprise from "./enterprise";
import Roadmap from "./roadmap";
import TermsCondtions from "./terms-conditions";



function App() {

  return (
    <BrowserRouter>
      <Routes>
        <Route exact key={"MainPage"} path="/" element={<MainPage />} />
        <Route exact key={"research"} path="/research" element={<ResearchPage />} />
        {/* <Route path="/ignitestudio" element={<Ignitestudio/>} /> */}
        <Route exact key={"ignite_studio"} path="/ignite_studio" element={<IgniteStudio />} />
        <Route exact key={"about"} path="/about" element={<IgniteCoin />} />
        <Route exact key={"ecosystem"} path="/ecosystem" element={<Enterprise />} />
        <Route exact key={"coming-soon"} path="/coming-soon" element={<Comingsoon />} />
        <Route exact key={"Media-assets"} path="/Media-assets" element={<MediaAssets />} />
        <Route exact key={"Privacy-Policy"} path="/Privacy-Policy" element={<PrivacyPolicy />} />
        <Route exact key={"Terms-Conditions"} path="/Terms-Conditions" element={<TermsCondtions />} />
        <Route exact key={"Roadmap"} path="/Roadmap" element={<Roadmap />} />
        <Route path="*" element={<Comingsoon />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;